import { useMemo } from 'react';
import { PropsBase } from '../model/props-base';
import { DynamicSVG } from './dynamic-svg.component';
import { SVGData } from 'nfty-common/lib/model/svg-data.model';

export interface QRCodeProps extends PropsBase {
    url?: string;
}

export const QRCode = ((props: QRCodeProps) => {
    const qrSVG = useMemo(createSVG, [props.url]);

    function createSVG() {
        if (props.url) {
            const qr = require('qr-image');
            const data = (qr.svgObject(props.url, { type: 'svg' })) as SVGData;
            return data;
        }
    }

    if (qrSVG) {
        return (
            <a target="_blank" href={props.url} rel="noreferrer">
                <DynamicSVG className="bg-white" width="100%" height="100%" svgPath={qrSVG.path} svgSize={qrSVG.size} />
            </a>
        );
    } else {
        return (null);
    }

});